var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification"},[_c('Popup',{attrs:{"mode":"notification","open":_vm.isOpen},on:{"closePopup":_vm.resetNotification}},[_vm._v(" "+_vm._s(_vm.notification)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }